import React from 'react';
import Box from '@mui/material/Box';
import { RakutenLogo } from '@rakutenfrance/shared-svg';
import { T, TolgeeProvider } from '@rakutenfrance/tolgee-provider';
import { colorPalette } from '../../../colorPalette';
import { staticData } from '../../../translate/tolgee';
export const ShippedByRakutenLabel = () => {
    return (React.createElement(TolgeeProvider, { ns: ['mui'], staticData: staticData },
        React.createElement(Box, { component: "span", sx: {
                display: 'inline-flex',
                alignItems: 'center',
                padding: '4px 8px',
                backgroundColor: colorPalette.white,
                color: colorPalette.red700,
                fontSize: '10px',
                borderRadius: '4px',
                border: `1px solid ${colorPalette.gray200}`,
                textTransform: 'uppercase',
            }, "data-qa": "shipped-by-rakuten-label" },
            React.createElement(Box, { component: "span" },
                React.createElement(T, { ns: "mui", keyName: "shipping_badge_shipped_by" }, "Exp\u00E9di\u00E9 par")),
            React.createElement(Box, { sx: { marginLeft: '2.5px', position: 'relative', top: '2.5px' } },
                React.createElement(RakutenLogo, { width: "39", height: "11" })))));
};
